import React from 'react';
import BackImg from 'assets/png/loginbg.jpg';
import Logo from 'assets/png/LogoDark.svg';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PublicRoutes } from 'routes/routeConstans';
import { MASTER_ENDPOINT } from 'utils/Constant';
import moment from 'moment';
import { useAppSelector } from 'store/hooks';
import { addNewData } from 'services/CommonServices';
import { logout } from 'store/actions/UserAction';
import { useDispatch } from 'react-redux';

const SSOLogout = () => {
  const navigate: any = useNavigate();
  const dispatch = useDispatch();

   const {
      userInfo: userDetail
    }: any = useAppSelector((store: any) => {
      return store.userLogin;
    });
  
  const goToLoginForm = () =>{
     navigate(PublicRoutes.SSOLOGIN);
  }

  const logoutFunction = () => {
      const isFromSSO = userDetail.isFromSSO     
      logout(dispatch);     
      addNewData(
        '',
        `${MASTER_ENDPOINT.LogoutUser}?clientId=${userDetail.ClientId ? userDetail.ClientId : 0
        }&userId=${userDetail.UserId}`,
      ).then(() =>{
        if(isFromSSO === 'True'){
          goToLoginForm();
        }
      })
    };

  React.useEffect(() => {
    logoutFunction();
  },[])
  
  React.useEffect(() => {    
    window.scrollTo(0, 0)
  }, [])

  return (
    <Grid container>
      <Grid item md={12} sm={12} xs={12}>
        <Typography
          component={'div'}
          sx={{ backgroundImage: `url(${BackImg})` }}
          className='login-banner'>
          <Typography component={'div'} className='login-box'>
            <Typography className='logo-text d-flex-a'>
              <img src={Logo} alt='People Optimization Index' />
            </Typography>
            <Typography component={'div'} style={{textAlign:'center'}}>
                Loging out of People Optimization Index
            </Typography>
            <Typography className='copy-text'>
              ©{moment().format('YYYY')} People Optimization Index, Inc. All rights reserved.
            </Typography>
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SSOLogout;